import React from 'react';

import { CircularProgress, Stack, Typography } from '@mui/material';

export function CustomOfferVendorVirtualCreditCardLoading() {
  return (
    <Stack direction="row" spacing={2} alignItems="center">
      <CircularProgress size={20} />
      <Typography variant="body2">Checking for existing virtual credit card for this custom offer.</Typography>
    </Stack>
  );
}
